import Vue from 'vue'
import Vuex from 'vuex'
import session from './modules/session'
import instituicoes from './modules/instituicoes'
import objetivos from './modules/objetivos'
import medidas from './modules/medidas'
import acoes from './modules/acoes'
import dimensoes from './modules/dimensoes'
import perguntas from './modules/perguntas'
import tipos from './modules/tipos'
import formularios from './modules/formularios'
import setores from './modules/setores'
import distritos from './modules/distritos'
import propostas from './modules/propostas'
import anos from './modules/anos'
import tipos_acao from './modules/tipos_acao'
import fases from './modules/fases'
import meses from './modules/meses'

Vue.use(Vuex)

export default new Vuex.Store({
modules: {
    session,
    instituicoes,
    objetivos,
    medidas,
    acoes,
    dimensoes,
    perguntas,
    tipos,
    formularios,
    setores,
    distritos,
    propostas,
    anos,
    tipos_acao,
    fases,
    meses
  },
  strict: false
})


// WEBPACK FOOTER //
// ./src/store/index.js